import React, { useState } from 'react';
import { motion } from "framer-motion";
import { Play, Pause } from "lucide-react";

interface CircularTextProps {
  text: string;
  onPlayToggle?: (isPlaying: boolean) => void;
  isPlaying?: boolean;
}

export const CircularText: React.FC<CircularTextProps> = ({ 
  text, 
  onPlayToggle,
  isPlaying = false 
}) => {
  const [localIsPlaying, setLocalIsPlaying] = useState(isPlaying);

  const handleClick = () => {
    const newPlayingState = !localIsPlaying;
    setLocalIsPlaying(newPlayingState);
    if (onPlayToggle) {
      onPlayToggle(newPlayingState);
    }
  };

  return (
    <div className="relative w-12 h-12 md:w-40 md:h-40">
      <motion.div
        className="absolute inset-0"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
        style={{ width: "100%", height: "100%" }}
      >
        <svg
          viewBox="0 0 200 200"
          className="w-full h-full fill-none stroke-white"
        >
          <path
            id="circlePath"
            d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
          />
          <text fontSize="18" className="md:text-[22px]">
            <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
              {text}
            </textPath>
          </text>
        </svg>
      </motion.div>
      <button
        onClick={handleClick}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 md:w-16 md:h-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center cursor-pointer group hover:bg-white/20 transition-all duration-300"
        aria-label={localIsPlaying ? "Pause video" : "Play video"}
      >
        {localIsPlaying ? (
          <Pause className="w-6 h-6 md:w-8 md:h-8 text-white group-hover:text-[#FF5A1F] transition-colors" />
        ) : (
          <Play className="w-6 h-6 md:w-8 md:h-8 text-white group-hover:text-[#FF5A1F] transition-colors ml-1" />
        )}
      </button>
    </div>
  );
};